module.exports = __webpack_public_path__ + "img/img_icon_28.0ec93cbc.png";